import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import initialState from './organizationComplianceInitialState';
import {
  _setContractAgency,
  _setReviewDate,
  _setClearDate,
} from './organizationComplianceActions';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getOrganizationComplianceForm = createAsyncThunk(
  'stop/getOrganizationComplianceForm',
  async (params) => {
    const { commonParams, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(commonParams, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const organizationComplianceSlice = createSlice({
  name: 'stop/organizationComplianceForm',
  initialState,
  reducers: {
    setContractAgency: _setContractAgency,
    setReviewDate: _setReviewDate,
    setClearDate: _setClearDate,
    resetOrganizationComplianceForm: (state) => initialState,
  },
  extraReducers: {
    [getOrganizationComplianceForm.fulfilled]: (state, action) =>
      action.payload,
  },
});

export const {
  setContractAgency,
  setReviewDate,
  setClearDate,
  resetOrganizationComplianceForm,
} = organizationComplianceSlice.actions;

export default organizationComplianceSlice.reducer;
